import { BigNumber, utils } from "ethers";
import { formatValueString } from ".";

export function toPercent(value: BigNumber, decimals = 16) {
  return `${formatValueString(utils.formatUnits(value, decimals), 4)}%`;
}
